    <!-- Body Content-->
    <div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4 body-content">

      <form  #form="ngForm" [formGroup]="staffAvailabilityConfigForm">
      <!-- Heading -->
        <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0">{{'STAFF_SCHEDULE.STAFF_AVAILABILITY' | translate }} <i
            class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2" pTooltip="Tooltip Content" tooltipStyleClass="text-xs"></i></h1>
      <!-- Heading -->

      <app-breadcrumb></app-breadcrumb>

      <!-- Skeleton -->
      <div *ngIf="showSkeleton" class="border-1 border-300 border-round shadow-1 surface-0 my-3">

        <!-- Top Part -->
        <div class="p-2 xl:flex align-items-center justify-content-between">
          <div class="xl:w-8 md:flex relative md:static pl-6 md:pl-0 pt-2 md:pt-0 mb-3 md:mb-0">
            <div class="md:mr-3 absolute md:static left-0 top-0">
              <p-skeleton styleClass="w-2rem h-2rem md:w-4rem md:h-4rem border-round"></p-skeleton>
            </div>
            <div class="flex flex-wrap align-items-center -mt-2">
              <p-skeleton width="3rem" height="1.35rem"></p-skeleton>
              <p-skeleton styleClass="mx-2" width="6rem" height="1.35rem"></p-skeleton>
              <p-skeleton width="4rem" height="1.35rem"></p-skeleton>
            </div>
          </div>
          <hr
            class="border-300 border-top-1 border-bottom-none border-left-none border-right-none xl:hidden mt-0 mb-1">
          <div class="xl:w-4 flex justify-content-between pt-2 xl:pt-0 xl:justify-content-end relative m-1">
            <p-skeleton width="8rem" height="2.2rem"></p-skeleton>
          </div>
        </div>
        <!-- Top Part -->

      </div>
      <!-- Skeleton -->

       <!-- Block -->
       <div *ngIf="!showSkeleton" class="border-1 border-300 border-round shadow-1 surface-0 my-3">
  
        <!-- Top Part -->
        <div class="p-2 xl:flex align-items-center justify-content-between" *ngIf="staffDetails$ | async as staff">

          <div class="xl:w-8 md:flex align-items-center relative md:static pl-6 md:pl-0 pt-2 md:pt-0 md:pt-0 mb-3 md:mb-0">
            <div class="md:mr-3 absolute md:static left-0 top-0">

                <ng-container *ngIf="staff.image;else noImage">
                  <p-avatar [image]="staff.image" shape="" styleClass="w-2rem h-2rem md:w-4rem md:h-4rem border-round"></p-avatar>
                </ng-container>
                <ng-template #noImage>
                  <p-avatar [label]="client2LetterName(staff.name) | titlecase | shortName" shape="" styleClass="w-2rem h-2rem md:w-4rem md:h-4rem border-round"></p-avatar>
                </ng-template>

              </div>
            <div class="flex flex-wrap align-items-center -mt-2">
              <p-tag styleClass="p-mr-2 text-xxs font-normal" severity="success" value="ACTIVE"
                [rounded]="false"></p-tag>
              <h4 class="text-primary mb-0 text-sm md:text-lg mx-2">{{ staff.name }}</h4>
              <div class="text-xs md:text-sm text-600"><span class="hidden md:inline">{{'STAFF_SCHEDULE.STAFF_ID' | translate}} - </span> {{ staff.id }}
              </div>
              <div class="text-xs md:text-sm text-600 w-full mt-1">{{ staff.department }} > {{ staff.designation }}</div>
            </div>
          </div>

          <hr
            class="border-300 border-top-1 border-bottom-none border-left-none border-right-none xl:hidden mt-0 mb-1">
          <div
            class="xl:w-4 flex justify-content-between border-300 pt-2 xl:pt-0 xl:justify-content-end relative m-1">
            <div
              class="bg-blue-50 border-primary flex align-items-center justify-content-center border-round text-xs md:text-sm text-primary p-2">
              <div><span>{{'STAFF_SCHEDULE.ACCESS_TEMPLATE' | translate}} - </span> <span class="md:font-bold uppercase">{{ staff.claim_template_name }}</span></div>
            </div>

          </div>
        </div>
        <!-- Top Part -->

      </div>
      <!-- Block -->


      <div class="flex align-items-center justify-content-center md:justify-content-end pb-3 mb-3">

      <!-- Tabs -->
      <div class="flex align-items-center">
      <span class="mr-2">{{'STAFF_SCHEDULE.SELECT' | translate}}</span>
      <p-select *ngIf="!showSkeleton" styleClass="w-13rem md:w-20rem text-sm" [options]="(staffAvailabilityConfig$ | async)!"  defaultLabel="None" optionLabel="name" 
         formControlName="staff_availability_config" (onChange)="SelectScheduleConfig($event)" [placeholder]="'STAFF_SCHEDULE.PLACEHOLDER_CONFIG' | translate">
      <ng-template pTemplate="selectedItem">
        <div *ngIf="SelectedAvailabilityFormControl.value" class="text-sm">
        <strong class="text-700">{{SelectedAvailabilityFormControl.value.name}}</strong>
        </div>
      </ng-template>
      <ng-template let-availability pTemplate="item">
        <div class="text-sm">{{availability.name}}</div>
      </ng-template>
    </p-select>
   
    <p-skeleton *ngIf="showSkeleton" width="10rem" height="2.2rem"></p-skeleton>
  </div>
      <!-- Tabs -->

      <span class="mx-2">{{'STAFF_SCHEDULE.OR' | translate }}</span>

      <!-- Create Schedule Button -->
      <div *ngIf="!showSkeleton" class="text-right">
        <p-button [label]="'STAFF_SCHEDULE.BTN_CREATE_NEW' | translate" (click)="CreateNewSchedule()" icon="fa fa-plus" styleClass="text-sm hidden md:inline-block"></p-button>
        <p-button icon="fa fa-plus"  (click)="CreateNewSchedule()" styleClass="text-sm md:hidden"></p-button>
      </div>
      <div *ngIf="showSkeleton">
        <p-skeleton width="10rem" height="2.2rem" styleClass="hidden md:inline-block"></p-skeleton>
        <p-skeleton width="2rem" height="2rem" styleClass="md:hidden"></p-skeleton>
      </div>
      <!-- Create Schedule Button -->

    </div>

      <!-- Card -->
      <div class="surface-0 border-round shadow-2">

        <!-- Message -->
        <div class="-my-3">
          <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="schedule-info-message" data-testid="schedule-info-message">
            {{ 'STAFF_SCHEDULE.SCHEDULE_INFO' | translate }}
          </p-message>
        </div>
        <!-- Message -->

        <!-- Top Part -->
        <div class="grid px-3 pb-3 pt-2">

          <!-- Column -->
          <div class="col-12 lg:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{ 'STAFF_SCHEDULE.SCHEDULE_NAME_LBL' | translate }}<sup
                class="p-error">*</sup></label>
            <input *ngIf="!showSkeleton" type="text" class="w-full text-sm" formControlName="name" pInputText [placeholder]="'STAFF_SCHEDULE.SCHEDULE_NAME_PLACE' | translate" />
            <app-error-msg *ngIf="NameFormControl.touched && NameFormControl.invalid"
               [errors]="NameFormControl.errors" [fieldLabel]=" 'STAFF_SCHEDULE.SCHEDULE_NAME' | translate">
            </app-error-msg>
            <p-skeleton *ngIf="showSkeleton" width="100%" height="2.2rem" styleClass="mb-1"></p-skeleton>
          </div>
          <!-- Column -->

          <!-- Column -->
          <div class="col-12 lg:col-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{ 'STAFF_SCHEDULE.CATEGORY' | translate }} <sup
                class="p-error">*</sup></label>
            <p-multiSelect *ngIf="!showSkeleton" styleClass="w-full text-sm" [options]="appointmentCategories" [showHeader]="false"
               defaultLabel="None" optionLabel="name_primary_language" [placeholder]="'STAFF_SCHEDULE.SElCT_APPT_CAT_PLAC' | translate"
               formControlName="appointment_catagories">
              <ng-template let-category pTemplate="item">
                <div class="text-sm">{{category.name_primary_language}}</div>
              </ng-template>
            </p-multiSelect>
            <p-skeleton *ngIf="showSkeleton" width="100%" height="2.2rem" styleClass="mb-1"></p-skeleton>
          </div>
          <!-- Column -->

        <!-- Column -->
        <div class="col-12 lg:col-4">
          <label class="font-medium text-700 text-xs mb-2 flex align-items-center uppercase">{{ 'STAFF_SCHEDULE.CAN_SCHEDULE' | translate }}
            <i class="fa fa-info-circle ml-2 text-600 cursor-pointer" pTooltip="Tooltip Content" tooltipStyleClass="text-xs"></i></label>
            <div class="w-full">
            <p-select *ngIf="!showSkeleton" [options]="schedules" formControlName="schedule_type" optionLabel="name" filterBy="name"
                styleClass="text-sm w-full md:25rem" [placeholder]="'ADMIN.COMMON.SELECT' | translate "  (onChange)="SelectSchduleType($event)">
            <ng-template pTemplate="selectedItem">
              <div *ngIf="SelectedScheduleTypeFormControl.value" class="text-sm">{{ 'STAFF_SCHEDULE.'+SelectedScheduleTypeFormControl.value.key | translate }} {{ GetSelectedDate(SelectedScheduleTypeFormControl.value.value) }}</div>
            </ng-template>
            <ng-template let-schedule pTemplate="item">
              <div class="text-sm">{{ 'STAFF_SCHEDULE.'+schedule.key | translate }}</div>
            </ng-template>
          </p-select>
          <app-error-msg *ngIf="SelectedScheduleTypeFormControl.touched && SelectedScheduleTypeFormControl.invalid"
             [errors]="SelectedScheduleTypeFormControl.errors" [fieldLabel]=" 'STAFF_SCHEDULE.SCHEDULE_TYPE' | translate">
           </app-error-msg>
          <p-skeleton *ngIf="showSkeleton" width="100%" height="2.2rem"></p-skeleton>
        </div>
      </div>
        <!-- Column -->

        </div>
        <!-- Top Part -->

        <!-- Bottom Part -->
        <div>

          <!-- Header -->
          <strong class="p-3 surface-200 block">{{ 'STAFF_SCHEDULE.SET_INTERVALS' | translate }}</strong>
          <!-- Header -->

          <!-- Content -->
          <div class="lg:flex">

            <!-- Left Side -->
            <div class="lg:w-8">
              <ul *ngIf="showSkeleton" class="list-none mx-0 px-3">
                <li class="border-bottom-1 border-300 p-3" *ngFor="let availability of [0,1,2,3,4,5,6]">
                  <div class="flex align-items-center justify-content-between">
                    <div class="flex align-items-center">
                    <p-skeleton styleClass="w-2rem h-2rem border-round"></p-skeleton>
                    <p-skeleton width="4rem" height="1.35rem" styleClass="ml-3"></p-skeleton>
                  </div>
                    <div class="flex align-items-center ml-2">
                      <p-skeleton styleClass="w-2rem h-2rem border-round ml-2"></p-skeleton>
                    </div>
                  </div>
                </li>
              </ul>
              <ul *ngIf="!showSkeleton" class="list-none mx-0 px-3">
                <li [ngClass]="getSelectedDayValue(day) ? 'surface-100' : '' " class="border-bottom-1 border-300 p-3" *ngFor="let day of WeekDays">
                
                  <div class="flex align-items-center justify-content-between">
                    <div class="flex align-items-center">
                      <p-toggleSwitch [formControlName]="'selectedDay_'+day" ></p-toggleSwitch>
                      <strong class="ml-3">{{ 'common.WEEKDAYS.'+day | translate }}</strong>
                    </div>
                    <div class="flex align-items-center ml-2">
                      <p-button icon="fa fa-copy font-light font-light" styleClass="p-button-outlined surface-0 ml-2" (click)="action.toggle($event)"></p-button>
                      <p-popover #action styleClass="overflow-hidden right-0 text-sm w-9rem">
                        <ng-template #content>
                          <div class="-m-2">
                          <h6 class="text-xs mb-3">{{ 'STAFF_SCHEDULE.COPY_TIMES_TO' | translate }}</h6>
                          <ul class="list-none m-0 p-0">
                            <form [formGroup]="checkBoxForm">
                              <li class="mt-2 pt-1 flex align-items-center" *ngFor="let copyToDay of WeekDays">
                                <p-checkbox checkboxIcon="fa fa-check" [formControlName]="copyToDay"  [binary]="true" [disabled]="day === copyToDay "></p-checkbox>
                                <label for="{{ copyToDay }} Checkbox" class="cursor-pointer ml-2">{{ 'common.WEEKDAYS.'+copyToDay | translate }}</label>
                              </li> 
                            </form>
                            </ul>
                            <p-button label="Apply" styleClass="text-sm mt-3 w-full" (click)="action.toggle($event);copyData(day)"></p-button>
                          </div>
                        </ng-template>
                      </p-popover>
                    </div>
                  </div>
                  <div *ngIf="SelectedDayValue(day)" >
                    
                    <div class="mt-4" [formArrayName]="'availableIntervals_'+day">
                    <h6 class="text-600 text-xs font-bold flex align-items-center mb-2">
                    <span>{{ 'STAFF_SCHEDULE.AVAILABILITY' | translate }}</span>
                    <i class="fa fa-info-circle ml-2 text-600 cursor-pointer" pTooltip="Tooltip Content"></i>
                    </h6>
                    <ng-container  *ngFor="let slot of getAvailableIntervalsFormControl(day).controls; let i = index;">
                      <div class="flex align-items-start md:align-items-center justify-content-between md:justify-content-start mb-2">
                        <div class="flex align-items-center"  [formGroupName]="i">
                          <p-datepicker hourFormat="12" formControlName="startTime" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem"
                           [ngClass]="hasStartTimeError(slot) ? 'ng-invalid ng-dirty' : ''">
                          </p-datepicker>
                          <div class="mx-2 text-center">{{ 'STAFF_SCHEDULE.TO' | translate }}</div>
                         <p-datepicker hourFormat="12" formControlName="endTime" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem"
                           [ngClass]="hasEndTimeError(slot) ? 'ng-invalid ng-dirty' : ''">
                         </p-datepicker>
                      </div>
                        <div class="flex align-items-center ml-3">
                          <p-button icon="fa fa-trash-alt" styleClass="p-button-outlined surface-0" (onClick)="removeAvailableInterval(day,i)"></p-button>
                          <p-button icon="fa fa-plus" styleClass="p-button-outlined surface-0 ml-2" (onClick)="addAvailableInterval(day)"></p-button>
                        </div>
                      </div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('duplicates')">{{ 'STAFF_SCHEDULE.MSG.DUPLICATE_TIMESLOT' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('overlaps')">{{ 'STAFF_SCHEDULE.MSG.TIMESLOT_OVERLAP' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('endBeforeStart')">{{ 'STAFF_SCHEDULE.MSG.ENDDATE_ERROR' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('unavailabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.AVAILABILITY_OVERLAP' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('availabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.AVAILABILITY_OVERLAP' | translate }}</div>
                    </ng-container>
                    
                    </div>
                  <div class="mt-4 mb-2" [formArrayName]="'unavailableIntervals_'+day">
                    <h6 class="text-600 text-xs font-bold flex align-items-center mb-2">
                    <span>{{ 'STAFF_SCHEDULE.UN_AVAILABILITY' | translate }}</span>
                    <i class="fa fa-info-circle ml-2 text-600 cursor-pointer" pTooltip="Tooltip Content"></i>
                    </h6>
                    <ng-container *ngFor="let slot of getUnAvailableIntervalsFormControl(day).controls; let j = index;">
                    <div class="flex align-items-start md:align-items-center justify-content-between md:justify-content-start mb-2">
                      <div class="flex align-items-center"  [formGroupName]="j">
                        <p-datepicker hourFormat="12"  formControlName="startTime" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem"
                         [ngClass]="hasStartTimeError(slot) ? 'ng-invalid ng-dirty' : ''">
                        </p-datepicker>
                      <div class="mx-2 text-center">{{ 'STAFF_SCHEDULE.TO' | translate }}</div>
                      <p-datepicker hourFormat="12" formControlName="endTime" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem"
                       inputStyleClass="w-full text-sm md:w-8rem" [ngClass]="hasEndTimeError(slot) ? 'ng-invalid ng-dirty' : ''">
                      </p-datepicker>
                    </div>
                      <div class="flex align-items-center ml-3">
                        <p-button icon="fa fa-trash-alt" styleClass="p-button-outlined surface-0" (onClick)="removeUnAvailableInterval(day,j)"></p-button>
                        <p-button icon="fa fa-plus" styleClass="p-button-outlined surface-0 ml-2" (onClick)="addUnavailableInterval(day)"></p-button>
                      </div>
                    </div>
                     <div class="p-error text-xs mt-1" *ngIf="slot.hasError('duplicates')">{{ 'STAFF_SCHEDULE.MSG.DUPLICATE_TIMESLOT' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('overlaps')">{{ 'STAFF_SCHEDULE.MSG.TIMESLOT_OVERLAP' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('endBeforeStart')">{{ 'STAFF_SCHEDULE.MSG.ENDDATE_ERROR' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('availabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.UNAVAILABILITY_OVERLAP' | translate }}</div>
                      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('unavailabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.AVAILABILITY_OVERLAP' | translate }}</div>

                      <div class="mt-4 mb-2 md:col-6 md:pr-5 pl-0" [formGroupName]="j">
                        <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.REASON_UN_AVAILABILITY' | translate }}</h6>
                        <textarea pInputTextarea class="w-full h-4rem" formControlName="reason_for_unavailability" placeholder=""></textarea>
                      </div>

                    </ng-container>
                    
                  </div>
                 
                  </div>
                </li>
              </ul>
            </div>
            <!-- Left Side -->

            <!-- Right Side -->
            <div class="lg:w-4 bg-blue-50 text-sm">

              <!-- Top Part -->
              <div class="p-4 border-bottom-1 border-300">
                <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.ADD_DATE_OVERRIDES' | translate }}</h6>
                <p *ngIf="!showSkeleton" class="text-600 mb-3">{{ 'STAFF_SCHEDULE.ADD_DATE_OVERRIDES_INFO' | translate }}</p>
                <p-skeleton *ngIf="showSkeleton" width="100%" height="1.35rem" styleClass="mb-3"></p-skeleton>
                <p-button *ngIf="!showSkeleton" (click)="dateOverride=true" (click)="dateSelected=false" styleClass="text-sm" [label]="'STAFF_SCHEDULE.ADD_OVERRIDE_DATE' | translate" icon="fa fa-plus"></p-button>
                <p-skeleton *ngIf="showSkeleton" width="10rem" height="2.2rem"></p-skeleton>
              </div>
              <!-- Top Part -->

               <!-- Bottom Part -->
              
               <div class="p-3 md:p-4 border-bottom-1 border-300" *ngFor="let exception of exception_dates_data;">
               
                <!-- Block -->
                <div class="mb-4">
                  <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.OVERRIDE_DATEs' | translate }}</h6>
                  <strong *ngIf="!showSkeleton">{{ exception.date  | datetimeformat : 'defaultformat' }}</strong>
                  <p-skeleton *ngIf="showSkeleton" width="7rem" height="1.35rem"></p-skeleton>
                </div>
                <!-- Block -->

                  <div class="mb-4">
                    <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.AVAILABILITY' | translate }}</h6>
                    <div class="flex" *ngIf="!showSkeleton && getAvailableIntervalsForOverrideDates(exception.intervals).length > 0">
                      <ul  class="list-none m-0 p-0">
                      <li *ngFor="let interval of getAvailableIntervalsForOverrideDates(exception.intervals);let i = index;" class="mt-1">
                        {{ parseTimeStringToDateTime(interval.From) | datetimeformat  : 'shortTime' }} to {{ parseTimeStringToDateTime(interval.to) | datetimeformat  : 'shortTime' }}
                      </li>
                      </ul>
                      <div  class="flex align-items-center ml-4">
                      <p-button (click)="editExceptionDate(exception)" icon="fa fa-pencil" styleClass="p-button-outlined surface-0 mr-2"></p-button>
                      <p-button (click)="deleteExceptionDate(exception)" icon="fa fa-trash-alt" styleClass="p-button-secondary text-600 surface-0 mr-2"></p-button>
                      </div>
                    </div>
                    <div class="flex" *ngIf="!showSkeleton && getAvailableIntervalsForOverrideDates(exception.intervals).length === 0">
                      <span>{{'STAFF_SCHEDULE.NO_AVAILABILITY' | translate }}</span>
                     </div>
                    <div class="flex" *ngIf="showSkeleton">
                      <ul class="list-none m-0 p-0">
                        <li class="mt-1"><p-skeleton width="7rem" height="1.35rem"></p-skeleton></li>
                        <li class="mt-1"><p-skeleton width="7rem" height="1.35rem"></p-skeleton></li>
                        </ul>
                      <div class="flex align-items-center ml-4">
                        <p-skeleton width="2rem" height="2rem" styleClass="mr-2"></p-skeleton>
                        <p-skeleton width="2rem" height="2rem" styleClass="mr-2"></p-skeleton>
                        </div>
                    </div>
                  </div>
                  <div class="mb-4">
                    <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.UN_AVAILABILITY' | translate }}</h6>
                    <div class="flex" *ngIf="!showSkeleton && getUnAvailableIntervalsForOverrideDates(exception.intervals).length > 0">
                      <ul  class="list-none m-0 p-0">
                        <li class="mt-1" *ngFor="let interval of getUnAvailableIntervalsForOverrideDates(exception.intervals); let i = index;">
                          {{ parseTimeStringToDateTime(interval.From) | datetimeformat  : 'shortTime'}} to {{ parseTimeStringToDateTime(interval.to) | datetimeformat  : 'shortTime'}}
                        </li>
                      </ul>
                      <div  class="flex align-items-center ml-4">
                      <p-button (click)="editExceptionDate(exception)" icon="fa fa-pencil" styleClass="p-button-outlined surface-0 mr-2"></p-button>
                      <p-button (click)="deleteExceptionDate(exception)" icon="fa fa-trash-alt" styleClass="p-button-secondary text-600 surface-0 mr-2"></p-button>
                      </div>
                    </div>
                    <div class="flex" *ngIf="!showSkeleton && getUnAvailableIntervalsForOverrideDates(exception.intervals).length === 0">
                      <span>{{'STAFF_SCHEDULE.NO_UN_AVAILABILITY' | translate }}</span>
                     </div>
                    <div class="flex" *ngIf="showSkeleton">
                      <ul class="list-none m-0 p-0">
                        <li class="mt-1"><p-skeleton width="7rem" height="1.35rem"></p-skeleton></li>
                        <li class="mt-1"><p-skeleton width="7rem" height="1.35rem"></p-skeleton></li>
                        </ul>
                      <div class="flex align-items-center ml-4">
                        <p-skeleton width="2rem" height="2rem" styleClass="mr-2"></p-skeleton>
                        <p-skeleton width="2rem" height="2rem" styleClass="mr-2"></p-skeleton>
                        </div>
                    </div>
                  </div> 

                  <div class="mb-4">
                    <h6 class="text-600 text-xs mb-2">{{ 'STAFF_SCHEDULE.UN_AVAILABILITY_REASON' | translate }}</h6>
                    <div *ngIf="!showSkeleton && getUnAvailableIntervalsForOverrideDates(exception.intervals).length > 0">
                      <ng-container *ngFor="let interval of getUnAvailableIntervalsForOverrideDates(exception.intervals);">
                        <span>{{ interval.reason_for_unavailability }}</span>
                      </ng-container>
                    </div>
                    <div *ngIf="!showSkeleton && getUnAvailableIntervalsForOverrideDates(exception.intervals).length === 0">
                      <span>-</span>
                     </div> 
                    <div *ngIf="showSkeleton">
                    <p-skeleton width="100%" height="1.35rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="100%" height="1.35rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="100%" height="1.35rem" styleClass="mb-1"></p-skeleton>
                  </div>
                </div>
              </div>
              <!-- Bottom Part -->

            </div>
            <!-- Right Side -->

          </div>
          <!-- Content -->

        </div>
        <!-- Bottom Part -->

      </div>
      <!-- Card -->

       <!-- Footer Buttons -->
       <div class="flex align-items-center justify-content-between my-3">
        <!-- <div *ngIf="staffAvailabilityConfigForm.invalid">
          <div *ngFor="let controlName of staffAvailabilityConfigForm.controls | keyvalue">
            <div *ngIf="staffAvailabilityConfigForm.get(controlName.key).invalid">
              <div *ngFor="let error of staffAvailabilityConfigForm.get(controlName.key).errors | keyvalue">
                {{ controlName.key }} - {{ error.key }}: {{ error.value }}
              </div>
            </div>
          </div>
        </div> -->
        <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"  styleClass="p-button-text text-sm" (onClick)="gobackTopage()"></p-button>
        <p-button [label]="'STAFF_SCHEDULE.BTN_SAVE_SCHEDULE' | translate"  [loading]="isSubmitting" styleClass="text-sm" (click)="SaveData()"></p-button>
      </div>
      <!-- Footer Buttons -->

    </form>
    </div>
    <!-- Body Content-->

        <!-- Date Override Modal  -->
<p-dialog [(visible)]="dateOverride" [resizable]="false" appendTo="body" [modal]="true"
[breakpoints]="{'767px': '100vw'}" [style]="{width: '540px'}" styleClass="no-header-modal">

<ng-template pTemplate="header" styleClass="hidden"></ng-template>
<ng-template pTemplate="content" styleClass="p-0">

  <!-- Header -->
  <div class="p-3 surface-0 sticky left-0 top-0 w-full z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm">{{ 'STAFF_SCHEDULE.SELECT_DATES' | translate }}</h2>
    <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeOerridePopup(selectedDate)"></div>
  </div>
  <!-- Header -->
  <form  #form="ngForm" [formGroup]="staffAvailabilityConfigDatesForm">
  <!-- Content -->
  <div class="surface-100 text-sm">
    <div class="-my-3">
    <p-message severity="info" icon="fa fa-info-circle" aria-label="can-choose-multiple-date-info-message" data-testid="can-choose-multiple-date-info-message">
      {{ 'STAFF_SCHEDULE.CAN_CHOOSE_MULTIPLE_DATE' | translate }}
    </p-message>
  </div>
    <p-datepicker selectionMode="multiple" formControlName="exception_dates" [inline]="true" styleClass="w-full" (onSelect)="createIntervalsOnDateSelect($event)"></p-datepicker>

    <div *ngIf="dateSelected">
    <div class="-my-3 surface-200">
      <p-message severity="custom" icon="fa fa-info-circle" aria-label="selected-dates-info-message" data-testid="selected-dates-info-message">
        {{ 'STAFF_SCHEDULE.SELECTED_DATES' | translate : { dates : getExceptionDates()} }}
      </p-message>
    </div>

    <div class="mx-4 pb-4" >
    <div class="mt-5"  [formArrayName]="'availableIntervalsDate_'+selectedDate">
      <div class="flex align-items-center my-3">
        <p-toggleSwitch [formControl]="getFormControlByName('is_full_day_unavailable_'+selectedDate)" (onChange)="setFullDatUnAvailable($event, selectedDate)"></p-toggleSwitch>
        <label class="ml-2">{{ 'STAFF_SCHEDULE.UNAVAILABLE_FOR_FULL_DAY' | translate }}</label>
      </div>
      <h6 class="text-600 text-xs font-bold flex align-items-center mb-2">
      <span>{{ 'STAFF_SCHEDULE.AVAILABILITY' | translate }}</span>
      <i class="fa fa-info-circle ml-2 text-600 cursor-pointer" pTooltip="Tooltip Content"></i>
      </h6>

      <ng-container  *ngFor="let slot of staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+selectedDate)!.controls; let i = index;">
        <div class="flex align-items-start md:align-items-center justify-content-between md:justify-content-start mb-2">
        <div class="flex align-items-center" [formGroupName]="i">
          <p-datepicker  formControlName="startTime" hourFormat="12" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem" 
           [ngClass]="hasStartTimeError(slot) ? 'ng-invalid ng-dirty' : ''">
          </p-datepicker>
        <div class="mx-2 text-center">{{ 'STAFF_SCHEDULE.TO' | translate }}</div>
        <p-datepicker formControlName="endTime" hourFormat="12" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem"
          inputStyleClass="w-full text-sm md:w-8rem" [ngClass]="hasEndTimeError(slot) ? 'ng-invalid ng-dirty' : ''"></p-datepicker>
      </div>
        <div class="flex align-items-center ml-3">
          <p-button icon="fa fa-trash-alt" (onClick)="removeAvailableIntervalDate(selectedDates[selectedDateIndex].date,i)"  styleClass="p-button-outlined surface-0" [disabled]="getFormControlByName('is_full_day_unavailable_'+selectedDate).value"></p-button>
          <p-button icon="fa fa-plus" (onClick)="addAvailableIntervalForDate(selectedDates[selectedDateIndex].date)" styleClass="p-button-outlined surface-0 ml-2" [disabled]="getFormControlByName('is_full_day_unavailable_'+selectedDate).value"></p-button>
        </div>
      </div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('duplicates')">{{ 'STAFF_SCHEDULE.MSG.DUPLICATE_TIMESLOT' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('overlaps')">{{ 'STAFF_SCHEDULE.MSG.TIMESLOT_OVERLAP' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('endBeforeStart')">{{ 'STAFF_SCHEDULE.MSG.ENDDATE_ERROR' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('unavailabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.AVAILABILITY_OVERLAP' | translate }}</div>

      </ng-container>
     

    </div>
    <div class="mt-3" [formArrayName]="'unavailableIntervalsDate_'+selectedDate">
      <h6 class="text-600 text-xs font-bold flex align-items-center mb-2">
      <span>{{ 'STAFF_SCHEDULE.UN_AVAILABILITY' | translate }}</span>
      <i class="fa fa-info-circle ml-2 text-600 cursor-pointer" pTooltip="Tooltip Content"></i>
      </h6>
      <ng-container  *ngFor="let slot of staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+selectedDate)!.controls; let j = index;">
      <div class="flex align-items-start md:align-items-center justify-content-between md:justify-content-start mb-2">
        <div class="flex align-items-center" [formGroupName]="j">
        <p-datepicker  formControlName="startTime" hourFormat="12" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem" [ngClass]="hasStartTimeError(slot) ? 'ng-invalid ng-dirty' : ''"></p-datepicker>
        <div class="mx-2 text-center">{{ 'STAFF_SCHEDULE.TO' | translate }}</div>
        <p-datepicker formControlName="endTime" hourFormat="12" [timeOnly]="true" [showIcon]="false" [placeholder]="'common.PLACEHOLDER.SELECT_TIME' | translate" styleClass="w-full md:w-8rem" inputStyleClass="w-full text-sm md:w-8rem" [ngClass]="hasEndTimeError(slot) ? 'ng-invalid ng-dirty' : ''"></p-datepicker>
      </div>
        <div class="flex align-items-center ml-3">
          <p-button icon="fa fa-trash-alt" (onClick)="removeUnAvailableIntervalDate(selectedDates[selectedDateIndex].date,j)" styleClass="p-button-outlined surface-0" [disabled]="getFormControlByName('is_full_day_unavailable_'+selectedDate).value"></p-button>
          <p-button icon="fa fa-plus" (onClick)="addUnAvailableIntervalForDate(selectedDates[selectedDateIndex].date)" styleClass="p-button-outlined surface-0 ml-2" [disabled]="getFormControlByName('is_full_day_unavailable_'+selectedDate).value"></p-button>
        </div>
      </div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('duplicates')">{{ 'STAFF_SCHEDULE.MSG.DUPLICATE_TIMESLOT' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('overlaps')">{{ 'STAFF_SCHEDULE.MSG.TIMESLOT_OVERLAP' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('endBeforeStart')">{{ 'STAFF_SCHEDULE.MSG.ENDDATE_ERROR' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('availabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.UNAVAILABILITY_OVERLAP' | translate }}</div>
      <div class="p-error text-xs mt-1" *ngIf="slot.hasError('unavailabilityOverlaps')">{{ 'STAFF_SCHEDULE.MSG.UNAVAILABILITY_OVERLAP' | translate }}</div>
      </ng-container>
    </div>
    <div class="mt-3">
      <h6 class="text-600 text-xs font-bold mb-2">
      <span>{{ 'STAFF_SCHEDULE.UN_AVAILABILITY_REASON' | translate }}</span>
      </h6>
      <textarea  [formControlName]="'unavailableIntervalsDateReason_'+selectedDate" pInputTextarea class="w-full h-4rem" placeholder=""></textarea>
    </div>
  </div>
  

</div>

  </div>
  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 surface-0 sticky left-0 bottom-0 w-full z-1 flex justify-content-between align-items-center border-top-1 border-300">
    <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"  styleClass="p-button-text text-sm" (click)="closeOerridePopup(selectedDate)"></p-button>
    <p-button [disabled]="!dateSelected" [label]="'STAFF_SCHEDULE.SAVE_CHANGES' | translate" styleClass="text-sm" (click)="SetOverrideDatesData()"></p-button>
  </div>
  <!-- Footer -->

  </form> 


</ng-template>

</p-dialog>
<!-- Date Override Modal  -->



<!-- Ongoing Date Modal -->
<p-dialog [(visible)]="onGoingDate" [resizable]="false" appendTo="body" [modal]="true"
[breakpoints]="{'767px': '100vw'}" [style]="{width: '480px'}" styleClass="no-header-modal">

<ng-template pTemplate="header" styleClass="hidden"></ng-template>
<ng-template pTemplate="content" styleClass="p-0">

  <form [formGroup]="staffAvailabilityConfigForm" id="onGoingDate">
  <!-- Header -->
  <div class="p-3 surface-0 sticky left-0 top-0 w-full z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm">{{ 'STAFF_SCHEDULE.ONGOINGDATESELECTION' | translate }}</h2>
    <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="CloseOngoingDateRange()"></div>
  </div>
  <!-- Header -->

  <!-- Content -->
  <div class="surface-100 text-sm">
    <div class="-my-3">
    <p-message severity="info" icon="fa fa-info-circle" aria-label="choose-starting-date-info-message" data-testid="choose-starting-date-info-message">
      {{ 'STAFF_SCHEDULE.CHOOSE_STARTING_DATE' | translate }}
    </p-message>
  </div>
    <p-datepicker formControlName="ongoing_date" [inline]="true" styleClass="w-full"  (onSelect)="OnGoingDateSelect()"></p-datepicker>
  </div>
  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 surface-0 sticky left-0 bottom-0 w-full z-1 flex justify-content-between align-items-center border-top-1 border-300">
    <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-text text-sm" (click)="CloseOngoingDateRange()"></p-button>
    <p-button [disabled]="!ongoingDateSelected" [label]="'common.BUTTONS.BTN_CONFIRM' | translate" styleClass="text-sm" (click)="onGoingDate=false"></p-button>
  </div>
  <!-- Footer -->

</form>

</ng-template>

</p-dialog>
<!-- Ongoing Date Modal  -->

<!-- Specific Date Range Modal -->
<p-dialog [(visible)]="specificDateRange" [resizable]="false" appendTo="body" [modal]="true"
[breakpoints]="{'767px': '100vw'}" [style]="{width: '480px'}" styleClass="no-header-modal">

<ng-template pTemplate="header" styleClass="hidden"></ng-template>
<ng-template pTemplate="content" styleClass="p-0">

  <form [formGroup]="staffAvailabilityConfigForm" id="specificDateRange">
  <!-- Header -->
  <div class="p-3 surface-0 sticky left-0 top-0 w-full z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm">{{ 'STAFF_SCHEDULE.SPECIFIC_DASTE_SELECTION' | translate }}</h2>
    <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="CloseSpecificDateRange()"></div>
  </div>
  <!-- Header -->

  <!-- Content -->
  <div class="surface-100 text-sm">
    <div class="-my-3">
    <p-message severity="info" icon="fa fa-info-circle" aria-label="choose-specific-date-info-message" data-testid="choose-specific-date-info-message">
      {{ 'STAFF_SCHEDULE.CHOOSE_SPECFIC_DATE' | translate }}
    </p-message>
  </div>
    <p-datepicker #calendar  formControlName="schedule_date_range" selectionMode="range" [inline]="true" styleClass="w-full" (onSelect)="onCustomDateSelect()"></p-datepicker>
  </div>

  <!-- Content -->

  <!-- Footer -->
  <div class="p-3 surface-0 sticky left-0 bottom-0 w-full z-1 flex justify-content-between align-items-center border-top-1 border-300">
    <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-text text-sm" (click)="CloseSpecificDateRange()"></p-button>
    <p-button [disabled]="!specificDateRangeSelected" [label]="'common.BUTTONS.BTN_CONFIRM' | translate" styleClass="text-sm" (click)="specificDateRange = false"></p-button>
  </div>
  <!-- Footer -->
</form>

</ng-template>

</p-dialog>
<!-- Specific Date Range Modal -->